// default configuration

module.exports = {
    disallowVars: false,
    disallowDuplicated: true,
    disallowUnknownReferences: true,
    parse: require("esprima-fb").parse,
};



//////////////////
// WEBPACK FOOTER
// ./~/defs/build/es5/options.js
// module id = 1107
// module chunks = 0